
<div class="layout-container">
  <div class="another">
    <div class="contact-details">
            <h2 class="heading-lg">{{ "Contact Info" }}</h2>
                <p class="text-block" >Phone: <a href="tel:+919986748794"><strong>{{"+91 9986748794"}}</strong></a></p>
                <p class="text-block">Email: <a href="mailto:contact@funfigz.com">{{"contact@funfigz.com"}}</a></p>

            <h2 class="heading-lg">{{ "Office Location" }}</h2>
            <p class="text-block">
                B-5, Sudarshanpura Industrial Area,
                22 Godam, Jaipur, Rajasthan-302006
            </p>
     
            <h2 class="heading-lg">{{ "Factory Location" }}</h2>
            <p class="text-block">
                B-5, Sudarshanpura Industrial Area,
                22 Godam, Jaipur, Rajasthan-302006
            </p>
            <h2 class="heading-lg">{{ "Working Hours"}}</h2>
            <p class="text-block">{{ "Monday - Friday - 9am to 6pm" }}</p>
            <p class="text-block">{{ "Saturday: Closed"}}</p>
            <p class="text-block">{{ "Sunday: Closed"}}</p>
    </div>

    <!-- submit section -->
    <div class="contact-form">
        <h2 class="heading-lg">{{ "Get In Touch" }}</h2>
        <p class="text-block">
            {{ "Thank you for your interest in Funfigz. Please fill out the form below and we will get in touch with you within 24 hours." }}
        </p>
        <div class="form">
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                <div class="fields">
                    <div class="input-field">
                        <label for="name" class="required">{{ "Name" }}</label>
                        <input
                            id="name"
                            type="text"
                            formControlName="name"
                            [placeholder]="'Full Name'"
                        />
                        <div *ngIf="isInvalid('name')">
                            <p class="error-text" *ngIf="isInvalid('name', 'required')">
                                {{ "Name"}}
                                {{ "field is mandatory." }}
                            </p>
                            <p class="error-text" *ngIf="isInvalid('name', 'forbiddenName')">
                                {{ "Name" }}
                                {{ "cannot contain numbers or special characters." }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field email">
                            <label for="email" class="required">{{ "Email" }}</label>
                            <input
                                id="email"
                                type="text"
                                formControlName="email"
                                [placeholder]="'Email'"
                            />
                            <div *ngIf="isInvalid('email')">
                                <p class="error-text" *ngIf="isInvalid('email', 'required')">
                                    {{ "Email" }}
                                    {{ "field is mandatory."}}
                                </p>
                                <p
                                    class="error-text"
                                    *ngIf="isInvalid('email', 'invalidEmail') && !isInvalid('email', 'required')"
                                >
                                    {{ "Please use a valid email format." }}
                                </p>
                            </div>
                        </div>
                        <div class="input-field subject">
                            <label for="subject" class="required">{{ "Subject" }}</label>
                            <input
                                id="subject"
                                type="text"
                                formControlName="subject"
                                [placeholder]="'Subject'"
                            />
                            <div *ngIf="isInvalid('subject')">
                                <p class="error-text" *ngIf="isInvalid('subject', 'required')">
                                    {{ "Subject" }}
                                    {{ "field is mandatory." }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="input-field">
                        <label for="message" class="required">{{ "Message" }}</label>
                        <textarea
                            id="message"
                            type="text"
                            formControlName="message"
                            rows="5"
                            [placeholder]="'Message'"
                        ></textarea>
                        <div *ngIf="isInvalid('message')">
                            <p class="error-text" *ngIf="isInvalid('message', 'required')">
                                {{ "Message" }}
                                {{  "field is mandatory." }}
                            </p>
                        </div>
                    </div>
                </div>
                    <button mat-flat-button class="all-button" [disabled]="this.contactForm.invalid" >
                        {{ "Submit"}}
                    </button>
            </form>
        </div>
    </div>
   </div> 
</div>


